import { MenuItem } from '../interface/MenuItem.interface';

export function getCollapseId(menuItem: MenuItem): string {
  return 'collapse-' + menuItem.path.replace(/\//g, '-');
}
